export const lang = {
    lang: 'CN',
    home: 'HOME',
    laureates: 'LAUREATES',
    Notice: 'Notice',
    nomination: 'NOMINATION',
    donors: 'DONORS',
    detialDondor: 'Donor',
    detialLaureates: 'Laureate',
    news: 'NEWS',
    events: 'EVENTS',
    awardabout: 'ABOUT',
    future: 'FUTURE FORUM',
    year: 'YEAR',
    years: 'Year',
    awards: 'AWARDS',
    winners: 'WINNERS',
    prize: 'PRIZE',
    //未来大奖周导航
    agenda: 'Agenda',
    academic: 'Academic Advisors',
    gegistration: 'Registration',
    partners: 'Partners',
    live: 'Live',
    legacy: 'Our Legacy',
    volunteer: 'Volunteer',
    contact: 'Contact Us',
    //论坛导航
    Home: 'Home',
    about: 'ABOUT',
    About: 'About',
    futureSience: 'Futrue Science Prize',
    whatWeDo: 'What We Do',
    futrueNews: 'Future News',
    contactUs: 'Contact Us',
    _2020FSPL: '2020 Future Science Prize Laureates',
    // nar_search: 'Search...',
    //关于导航
    aboutFSP: 'Future Science Prize',
    Bylaw: 'Bylaw',
    Sciencecommittee: 'Science Committee',
    Supervisorycommittee: 'Supervisory Committee',
    Contactus: 'Contact us',
    WINNERS: 'WINNERS',
    YEAR: 'YEAR',
    Year: 'Year',
    AWARDS: 'AWARDS',
    menuPrize: 'Prize',
    Lifescienceprize: 'The Life Science Prize',
    Physicalscienceprize: 'The Physical Science Prize',
    MCprize: 'The Mathematics and Computer Science Prize',
    mununotice: 'Notice',
    PressConference: 'Press Conference',
    IwithL: 'Interview with Laureates',
    NandI: 'News and Insights',
    nar_search: 'Search...',
    // forumViews导航
    VandM: 'Vision and Mission',
    fminiAboutUs: 'About Us',
    fmsciencec: 'Science Committee',
    Awardceremony: 'Award Ceremony',
    Laureateslecture: 'Laureates Lecture',
    Inspirationinitiative: 'Inspiration Initiative',
    Selectionrules: 'Selection Rules',
    AllLaureates: 'All Laureates',
    Donor: 'Donors:',
    Reward: 'Rewards:',
    IwithLauretes: 'Interview with Laureates',
    LatestNews: 'Latest News',
    RelatedVideo: 'Related Video',
    CFSPDC: 'Chairman, Future Science Prize Donor’s Congress',
    Prizedonor: 'Prize Donors',
    laureate: 'laureates',
    FSPSymposium: 'Future Science Prize Symposium',
    FLSeries: 'Future Lecture Series',
    FutureRoundtable: 'Future Roundtable',
    FutureReception: 'Future Reception',
    CitySummit: 'City Summit',
    RotatingChair: 'Rotating Chair',
    SubcommitteeChair: 'Subcommittee Chair',
    Members: 'Members',
    FormerMembers: "Former Members",
    Council: 'Council',
    MembersList: 'Members List',
    ExecutiveCommittee: 'Executive Committee',
    InstitutionalCouncil: 'Institutional Council',
    YouthCouncil: 'Youth Council',
    YOSIA: 'YOSIA',
    FSPW2020: '2020 Future Science Prize Week',
    FSPW2019: '2019 Future Science Prize Week',
    FSPW2021: '2021 Future Science Prize Week',
    Symposium: 'Symposium',
    AwardCeremony: 'Award Ceremony',
    index2020: '2020 Future Science Prize Laureates',
    Responsibility: 'Responsibility',
    oversighttho: 'Oversight the operations',
    Oversighttsp: 'Oversight the selection process',
    Ensuretapc: 'Ensure transparency and public confidence',
    viuuesHuman: '病毒与人类健康专题科普',
    cityMeeting: 'City Summit',
    futureNew: ' News Release',
    mediaNew: 'Media Coverage',
    AIscience: 'AI+科学系列',
    cooparationSupport: 'Corporate Partner',
    mediaSupport: 'Media Partner',
    amedemicConcil: 'Academic Partners',
    VoluteerSign: 'Volunteer',
    traineeSign: 'Internship',
    FulltimeJob: 'Job Opportunities',
    YOSIA: 'YOSIA',
    YOSIAWebinar: 'YOSIA Webinar',
    partner: 'partner',
    attention: "Attention ",
    HandtInformartion: "  Hand transportation information ",
    Nominatedtime: "Nominated Time",
    STRATEGICPARTNERS: "STRATEGIC PARTNERS",
    mattersneedattention: "Matters Need Attention",
    Hotelandtransportationinformation: "Hotel And Transportation Information",
    time: 'Publish Time',
    groupPart: 'groupPart',
    RelatedReading: 'Related Reading',
    Speeches: 'Speeches',
    LecturerProfiles: 'Lecturer Profiles',
    inputPe: 'Transform the Future with Science',
    Summary: 'Summary',
    Enroll: 'Enroll',
    UploadResume: 'Upload Resume',
    submit: 'Submit',

}